import React, { Component } from 'react';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import { withAppStorage } from '../utils/appStorage';

import { InfoNotice, AlertNotice } from './Notices';
import { Button, TextButton } from './Buttons';
import { regNumber } from '../utils/validators';

const Title = styled.h2`
  font-weight: 500;
`;

const Content = styled.p`
  font-weight: 300;
  line-height: 2;
`;

const Form = styled.form`
  display: flex;
  justify-content: center;
`;

const ValidationMessage = styled.div`
  color: ${p => p.theme.colors.error};
  font-size: 0.875rem;
  margin-top: 10px;
`;

const RegistrationNumberInput = styled.input`
  padding: 11px 20px;

  ${breakpoints.large`
        margin-right: 10px;
    `};
`;

class RegistrationNumberNotice extends Component {
  state = {
    regNumber: '',
    validation: ''
  };

  handleRegNumberChange = event => {
    this.setState({
      regNumber: event.target.value,
      validation: ''
    });
  };

  handleRegNumberSubmit = event => {
    event.preventDefault();
    if (!this.state.regNumber || !regNumber(this.state.regNumber)) {
      this.setState({
        validation: 'Vennligst skriv inn et registreringsnummer!'
      });

      return null;
    }

    this.props.appStorage.set('regNumber', this.state.regNumber.toUpperCase());
  };

  handleRegNumberRemove = () => {
    this.setState({ regNumber: '' });
    this.props.appStorage.delete('regNumber');
  };

  render() {
    const { regNumber } = this.props.appStorageData;

    if (!regNumber) {
      return (
        <AlertNotice>
          <Title>Registreringsnummer mangler.</Title>

          <Content>
            Vi anbefaler at du skriver inn registreringsnummerslik at vi kan dobbeltsjekke om delene passer til din bil.
          </Content>

          <Form onSubmit={this.handleRegNumberSubmit}>
            <RegistrationNumberInput
              placeholder="Registreringsnummer…"
              value={this.state.regNumber}
              onChange={this.handleRegNumberChange}
            />

            <Button>Velg</Button>
          </Form>

          {this.state.validation && (
            <ValidationMessage>{this.state.validation}</ValidationMessage>
          )}
        </AlertNotice>
      );
    }

    return (
      <InfoNotice>
        <Title>Registreringsnummer: {regNumber}</Title>

        <TextButton onClick={this.handleRegNumberRemove}>
          Endre kjøretøy
        </TextButton>
      </InfoNotice>
    );
  }
}

export default withAppStorage(RegistrationNumberNotice);
